<template>
  <v-form v-model="formValid">
    <v-subheader class="font-italic font-weight-light py-1">Generale</v-subheader>
    <v-row no-gutters class="py-1">
      <v-col>
        <v-text-field
          v-model="name"
          :rules="[max255CharRule, presenceRule]"
          dense
          filled
          label="Nome"
          hide-details="auto"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import Vue from 'vue'
import hairColorForm from '@/services/hairColors/hairColor.form.js'

export default {
  name: "GeneralFormTab",
  components: {},
  data: function() {
    return {
      name: undefined,
      description: undefined,
      loadingHairColor: false,
      formValid: false,
      max255CharRule: (v) => {
        if(v) {
          return v.length <= 255 || 'Al massimo 255 caratteri'
        } else {
          return true
        }
      },
      presenceRule: (v) => {
        return !!v || 'Il campo è obbligatorio'
      },
    };
  },
  props: {
    bus: {
      type: Object,
      default: function() {
        return new Vue()
      }
    }
  },
  mounted: function() {
    this.handleObjectChanges(hairColorForm.hairColor)

    var self = this
    hairColorForm.on('update', function(data) {
      self.handleObjectChanges(data.hairColor)
    })
  },
  methods: {
    fields() {
      return ['name', 'description']
    },
    handleObjectChanges(hairColor) {
      const fields = this.fields()
      const newValKeys = Object.keys(hairColor)

      for(let i = 0; i < fields.length; i++) {
        const field = fields[i]
        if(newValKeys.includes(field) && hairColor[field] != this[field]) {
          this[field] = hairColor[field]
        }
      }
    },
  },
  watch: {
    formValid(newVal) {
      this.$emit('update:valid', newVal)
      if(this.bus) {
        this.bus.$emit('update:valid', newVal)
      }
      hairColorForm.setValid(newVal)
    },
    name(newVal) {
      hairColorForm.updateField('name', newVal)
    },
    description(newVal) {
      hairColorForm.updateField('description', newVal)
    },
  }
};
</script>